// URL publique du worker. Configurable via env CRA pour les deploiements
// alternatifs ; fallback sur l instance prod par defaut.
//
// Phase 2 fermeture R2 (2026-06-24) : R2_PUBLIC retire — tous les acces
// au bucket passent desormais par le worker (/cover/:slug public,
// /admin/photo/:key avec X-Admin-Secret). Plus aucune URL pub-*.r2.dev
// dans le code dashboard.
export const WORKER_URL =
  process.env.REACT_APP_WORKER_URL || "https://will-api.geoffreyzigante.workers.dev";

// Origine canonique des galeries publiques d'evenements — la vitrine
// will-app.com (decision brief 2026-06-01, audit cross-surface). Path
// canonique : /event/{slug} (singulier). Le dashboard a un 301
// /events/{slug} -> vitrine /event/{slug} pour les anciens liens (cf
// public/_redirects), mais on emet desormais directement les URLs vitrine
// dans les QR codes / partages.
// Override via env si on deploie sur un autre domaine (preview, staging, ...).
export const GALLERY_BASE_URL =
  process.env.REACT_APP_GALLERY_BASE_URL || "https://will-app.com";

// Slugs interdits — collisions avec le routing front path-based.
// Doit rester synchro avec worker/index.js#RESERVED_SLUGS.
export const RESERVED_SLUGS = new Set([
  "events", "event", "orga", "admin", "photographe",
  "dashboard", "api", "static", "_assets", "",
]);

export function buildGalleryUrl(slug) {
  return `${GALLERY_BASE_URL}/event/${encodeURIComponent(slug)}`;
}
